import React, { useEffect } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import TopBanner from "../components/TopBanner";

const Contact = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const constainerVariant = {
    hidden: {
      scaleX: 0,
    },
    visible: {
      scaleX: 1,
      transition: { type: "spring", stiffness: 50 },
    },
    exit: {
      scaleX: 0,
      transition: { ease: "easeInOut" },
    },
  };

  return (
    <>
      <motion.div
        variants={constainerVariant}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <Container>
          <TopBanner
            loaction1={"Currently"}
            location2={"Frontend Developer"}
            place1={"Based in Abuja"}
            place2={"Nigeria"}
          />

          <Main>
            <Mail>
              <h2>send me a message</h2>
              <a
                href="mailto:damaluku@gmail.com"
                target="_blank"
                rel="noreferrer"
              >
                damaluku@gmail.com
              </a>
            </Mail>
            <Social>
              <h2>or connect with me on social</h2>
              <Media>
                <a
                  href="https://github.com/damaluku"
                  target="_blank"
                  rel="noreferrer"
                  data-aos="flip-left"
                >
                  Github
                </a>
                <a
                  href="https://www.upwork.com/freelancers/~015700480d81126654"
                  target="_blank "
                  data-aos="flip-left"
                  rel="noreferrer"
                >
                  Upwork
                </a>
                <a
                  href="https://www.linkedin.com/in/damian-aluku-59b06023a"
                  target="_blank"
                  rel="noreferrer"
                  data-aos="flip-left"
                >
                  linkedin
                </a>
              </Media>
            </Social>
          </Main>
        </Container>
      </motion.div>
    </>
  );
};

export default Contact;

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
`;

const Main = styled.main`
  width: 100%;
  min-height: 100vh;
  margin-bottom: 5rem;
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-row-gap: 4rem;
  z-index: 1;

  @media screen and (max-width: 760px) {
    display: block;
    margin: auto;
  } ;
`;

const Mail = styled.div`
  width: 100%;
  text-align: center;
  z-index: 1;
  position: relative;

  h2 {
    font-size: 25px;
    text-transform: uppercase;
    margin-bottom: 3rem;
  }
  a {
    font-size: 60px;
    text-transform: uppercase;
    font-weight: bold;
  }

  @media screen and (max-width: 760px) {
    h2 {
      font-size: 25px;
    }
    a {
      font-size: 25px;
    }
  } ;
`;

const Social = styled.div`
  width: 100%;
  text-align: center;
  z-index: 1;
  position: relative;

  h2 {
    font-size: 25px;
    text-transform: uppercase;
    margin-bottom: 3rem;
  }
  a {
    font-size: 60px;
    text-transform: uppercase;
  }

  @media screen and (max-width: 760px) {
    margin-top: 10rem;

    a {
      font-size: 25px;
    }
  }
`;

const Media = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 1;

  a {
    margin-top: 2rem;
    align-self: center;
  }
`;
